import { clampPercent, formatNumber, localizedText } from 'shared/utilities/format';
import { getLocale } from 'core/i18n/localeStore';
import { resolvePatternAppearance } from 'theme/patternColors';

export function PatternChip({ pattern, locale }) {
  const appearance = resolvePatternAppearance(pattern);
  return (
    <span className={`chip pattern-chip pattern-chip-${appearance.key}`}>
      <span className="pattern-swatch" style={{ background: appearance.color }} aria-hidden="true" />
      {localizedText(pattern, locale)}
    </span>
  );
}

export function PatternBar({
  name,
  percentage,
  color,
  foreground,
  description,
  isTop,
  isTied,
  topLabel,
  tiedLabel,
  rank,
  patternKey,
}) {
  const value = clampPercent(percentage);
  const fill = color || 'var(--pacilo-pattern-teal)';
  const rankColor = foreground || 'var(--pacilo-navy-900)';
  return (
    <div className="pattern-bar" data-pattern={patternKey || undefined}>
      <div className="pattern-bar-head">
        <span className="pattern-bar-title">
          {rank != null ? (
            <span className="pattern-rank" style={{ background: fill, color: rankColor }}>{rank}</span>
          ) : null}
          <strong>{name}</strong>
        </span>
        <span>{formatNumber(value, getLocale())}%</span>
      </div>
      <div
        className="pattern-track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={value}
        aria-label={name}
      >
        <div
          className="pattern-fill"
          style={{ width: `${value}%`, background: fill }}
        />
      </div>
      <div className="pattern-meta">
        {isTop ? <span className="chip chip-accent">{topLabel}</span> : null}
        {isTied ? <span className="chip chip-warning">{tiedLabel}</span> : null}
      </div>
      {description ? <p className="muted">{description}</p> : null}
    </div>
  );
}

export function ProgressIndicator({ current, total, label }) {
  const safeTotal = Number(total) || 0;
  const safeCurrent = Number(current) || 0;
  const value = safeTotal > 0 ? Math.round((safeCurrent / safeTotal) * 100) : 0;
  return (
    <div className="progress-indicator">
      {label ? <p className="progress-label">{label}</p> : null}
      <div
        className="progress-track"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={value}
        aria-label={label}
      >
        <div className="progress-fill" style={{ width: `${value}%` }} />
      </div>
    </div>
  );
}
